import { stagingCheck, productionCheck } from 'services/config'
import Script from 'next/script'

function ExternalScripts() {
  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: ` if (window.location.origin.includes("https://webcache.googleusercontent.com") || window.location.origin.includes("http://webcache.googleusercontent.com")) { window.OhistoryReplaceState = window.history["replaceState"]; window.history["replaceState"] = (...args)=> { try { return window.OhistoryReplaceState.apply(window.history, args) } catch (e) { console.log(e) } }; window.OhistoryPushState = window.history["pushState"]; window.history["pushState"] = (...args)=> { try { return window.OhistoryPushState.apply(window.history, args) } catch (e) { console.log(e) } }; } `,
        }}
        strategy="lazyOnload"
      />
      <Script
        id="statcounter_vars"
        dangerouslySetInnerHTML={{
          __html: `
        var sc_project=10912261; 
        var sc_invisible=1; 
        var sc_security="6214d8ff"; 
        `,
        }}
        strategy="lazyOnload"
      />
      <Script
        id="statcounter"
        type="text/javascript"
        src="https://www.statcounter.com/counter/counter.js"
        async
        strategy="lazyOnload"
      />

      {productionCheck === 'PRODUCTIONS' && (
        <Script
          strategy="lazyOnload"
          id="zopim_chat"
          dangerouslySetInnerHTML={{
            __html: `function chat_footer() {
            var e, t, o, i, n;
            window.$zopim || (e = document, t = "script", o = $zopim = function(e) {
                o._.push(e)
            }, i = o.s = e.createElement(t), n = e.getElementsByTagName(t)[0], o.set = function(e) {
                o.set._.push(e)
            }, o._ = [], o.set._ = [], i.async = !0, i.setAttribute("charset", "utf-8"), i.src = "https://v2.zopim.com/?3qFSaNHMIF2pBcGz43BMInkGg6Li7WOr", o.t = +new Date, i.type = "text/javascript", n.parentNode.insertBefore(i, n))
            
            window.zESettings = {
              webWidget: {
                launcher: {
                  label: {
                    'en-US': 'Chat With Us',
                    '*': 'Chat with us'
                  },
                },
              }
            };
            function showzopim() {
              if (window.innerWidth > 767) {
                window.$zopim.livechat.window.show();
              }
            }
            function handleZopimResize() {
              if (window.$zopim) {
                if (window.innerWidth <= 767) {
                  if (!$zopim.livechat.window.getDisplay()) {
                    window.$zopim.livechat.button.hide();
                    window.$zopim.livechat.window.hide();
                  }
                } else {
                  window.$zopim.livechat.button.show();
                }
              }
            }
            window.addEventListener('resize', handleZopimResize);
            let zopimInterval = setInterval(() => {
                if (typeof window.$zopim === 'function' && typeof window.$zopim.livechat == 'object') {
                    clearInterval(zopimInterval);
                    window.$zopim.livechat.window.onHide(() => {
                        handleZopimResize();
                    });
                    handleZopimResize();
                }
            }, 1000)
            setTimeout(function() {
              showzopim();
            }, 15000);
          }
        setTimeout(function() {
            chat_footer();
        }, 1000);
        `,
          }}
        />
      )}

      <noscript>
        <div className="statcounter">
          <a
            title="Web Analytics
        Made Easy - Statcounter"
            href="https://statcounter.com/"
            rel="noreferrer"
            target="_blank"
          >
            <img
              className="statcounter"
              src="https://c.statcounter.com/10912261/0/6214d8ff/1/"
              alt="Web Analytics Made Easy - Statcounter"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </a>
        </div>
      </noscript>
    </>
  )
}
export default  ExternalScripts
